import { Box, Typography } from "@mui/material";
import { palette } from "../../../styles/theme";

interface DesignDragPreviewProps {
  designName: string;
  firstImageUrl?: string;
  secondImageUrl?: string;
}

export const DesignDragPreview = ({
  designName,
  firstImageUrl,
  secondImageUrl,
}: DesignDragPreviewProps) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        backgroundColor: palette.white,
        border: `1px solid ${palette.blue.secondary}`,
        borderRadius: "12px",
        boxShadow: "0px 8px 32px rgba(0, 0, 0, 0.3)",
        width: "200px",
        cursor: "grabbing",
        opacity: 0.5,
        pointerEvents: "none",
      }}
    >
      <Box
        sx={{
          width: "100%",
          height: "150px",
          borderRadius: "10px 10px 0 0",
          backgroundColor: palette.white,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          border: `1px solid ${palette.grey.lightGrey}`,
          overflow: "hidden",
          position: "relative",
          gap: 1.5,
        }}
      >
        {firstImageUrl || secondImageUrl ? (
          <>
            {firstImageUrl && (
              <Box
                component="img"
                src={firstImageUrl}
                draggable={false}
                sx={{
                  maxHeight: "100px",
                  maxWidth: secondImageUrl ? "45%" : "90%",
                  objectFit: "contain",
                  userSelect: "none",
                }}
              />
            )}
            {secondImageUrl && (
              <Box
                component="img"
                src={secondImageUrl}
                draggable={false}
                sx={{
                  maxHeight: "100px",
                  maxWidth: firstImageUrl ? "45%" : "90%",
                  objectFit: "contain",
                  userSelect: "none",
                }}
              />
            )}
          </>
        ) : (
          <Box
            sx={{
              width: "80px",
              height: "80px",
              backgroundColor: palette.grey.midGrey,
              borderRadius: "8px",
              opacity: 0.3,
            }}
          />
        )}
      </Box>

      <Box
        sx={{
          padding: "12px",
          display: "flex",
          flexDirection: "column",
          gap: "4px",
        }}
      >
        <Typography
          variant="textSm"
          sx={{
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {designName}
        </Typography>
      </Box>
    </Box>
  );
};
